import { render } from "./DescriptionSection.vue?vue&type=template&id=acfc7ad2&scoped=true"
import script from "./DescriptionSection.vue?vue&type=script&lang=js"
export * from "./DescriptionSection.vue?vue&type=script&lang=js"

import "./DescriptionSection.vue?vue&type=style&index=0&id=acfc7ad2&lang=scss&scoped=true"
import "./DescriptionSection.vue?vue&type=style&index=1&id=acfc7ad2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acfc7ad2"]])

export default __exports__